export default __webpack_public_path__ + "static/no-poverty-93da7ec2782ac6ef0b38945d62f6afc6.png";